import { token } from '../../localStorage'
import { BASE_URL } from '../constants'

export const TYPE_FORM_ID = Object.freeze({
  COMPANY_FISCAL_DATA_STEP_ONE: 1,
})

// ─── Form Types ────────────────────────────────────────────────────────────

export const getFormTypesList = () => {
  const URL = `${BASE_URL}forms/types/list`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((res) => res.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const getFormTypeOne = (id) => {
  const URL = `${BASE_URL}forms/types/one?id=${id}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((res) => res.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const createFormType = async ({ name, description = '' }) => {
  const URL = `${BASE_URL}forms/types/create`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: JSON.stringify({ name, description }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const updateFormType = async ({ id, name, description, active }) => {
  const URL = `${BASE_URL}forms/types/update`

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: JSON.stringify({ id, name, description, active }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const deleteFormType = async (id) => {
  const URL = `${BASE_URL}forms/types/delete?id=${id}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

// ─── Form Save ─────────────────────────────────────────────────────────────

export const getFormSaveOne = (typeFormId) => {
  const URL = `${BASE_URL}forms/save/one?typeFormId=${typeFormId}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((res) => res.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const createFormSave = async ({ typeFormId, form }) => {
  const URL = `${BASE_URL}forms/save`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: JSON.stringify({ typeFormId, form }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const deleteFormSave = async (typeFormId) => {
  const URL = `${BASE_URL}forms/save/delete?typeFormId=${typeFormId}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    return response
  } catch (error) {
    console.log(error)
  }
}
